/**
 * @generated SignedSource<<8bc3b9f93a6bd7b879df90624f796614>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FinancialAggregatedNumber = "actualRevenue" | "billableActualTimeAndExpenses" | "nonBillableActualTimeAndExpenses" | "allActualTimeAndExpenses" | "actualCost" | "actualProfit" | "actualRevenueProfit" | "actualMargin" | "actualRevenueMargin" | "plannedRevenue" | "billablePlannedTimeAndExpenses" | "nonBillablePlannedTimeAndExpenses" | "allPlannedTimeAndExpenses" | "plannedCost" | "plannedProfit" | "plannedRevenueProfit" | "plannedMargin" | "plannedRevenueMargin" | "remainingRevenue" | "billableForecastTimeAndExpensesToComplete" | "nonBillableForecastTimeAndExpensesToComplete" | "allForecastTimeAndExpensesToComplete" | "remainingCost" | "forecastCostToComplete" | "remainingProfit" | "forecastProfitToComplete" | "forecastRevenueProfitToComplete" | "remainingMargin" | "forecastMarginToComplete" | "forecastRevenueMarginToComplete" | "forecastRevenue" | "billableTotalTimeAndExpensesAtCompletion" | "nonBillableTotalTimeAndExpensesAtCompletion" | "allTotalTimeAndExpensesAtCompletion" | "forecastCost" | "totalCostAtCompletion" | "forecastProfit" | "totalProfitAtCompletion" | "totalRevenueProfitAtCompletion" | "forecastMargin" | "totalMarginAtCompletion" | "totalRevenueMarginAtCompletion" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineCost" | "baselineProfit" | "baselineMargin" | "baselineVsActualRevenue" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualProfit" | "baselineVsActualMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueMargin" | "baselineVsForecastRevenue" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsAllActualValueOfService" | "baselineVsAllProjectedValueOfService" | "estimatedVsAllActualValueOfService" | "estimatedVsAllProjectedValueOfService" | "baselineVsForecastCost" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsForecastProfit" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineMinutes" | "planVsActualRevenue" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsActualCost" | "planVsActualProfit" | "planVsActualMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueMargin" | "planVsForecastRevenue" | "planVsForecastCost" | "planVsForecastProfit" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "recognitionLockedRevenue" | "registeredMinutes" | "billableActualMinutes" | "nonBillableActualMinutes" | "remainingMinutes" | "forecastTimeToComplete" | "forecastMinutes" | "totalTimeAtCompletion" | "scopeApprovedMinutes" | "scopeTotalMinutes" | "allocationMinutes" | "invoiced" | "paid" | "accruedDeferred" | "baselineVsRegisteredMinutes" | "baselineVsForecastMinutes" | "baselineVsTotalTimeAtCompletion" | "registeredVsScopeApprovedMinutes" | "scopeApprovedVsRegisteredMinutes" | "forecastVsScopeApprovedMinutes" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "billableTime" | "recognitionPercentage" | "recognitionAmount" | "surplus" | "surplusPercentage" | "estimatedCost" | "recognitionProfit" | "recognitionProfitPercentage" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionForecastRevenue" | "totalRevenueRecognition" | "estimatedCostPercentage" | "expenseRevenuePercentage" | "expenseCostPercentage" | "recognitionOpenRevenue" | "actualOpenRevenue" | "actualLockedRevenue" | "totalActualRevenueRecognition" | "forecastOpenRevenueToComplete" | "forecastLockedRevenueToComplete" | "totalForecastRevenueToComplete" | "suggestedRevenue" | "suggestedRevenuePercentage" | "suggestedProfit" | "suggestedProfitPercentage" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type ProjectPortfolioMonthByMonthClientDownload_Query$variables = {
  startYear: number;
  startMonth: number;
  startDay: number;
  endYear: number;
  endMonth: number;
  endDay: number;
  searchQuery: TaskSearchQueryType;
  timeSearchQuery: TaskSearchQueryType;
  expenseSearchQuery: TaskSearchQueryType;
  selectedSingleValue: FinancialAggregatedNumber;
  ignoreBaselineWinChance?: boolean | null;
  excludeOpportunityActuals?: boolean | null;
};
export type ProjectPortfolioMonthByMonthClientDownload_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectPortfolioMonthByMonthClientDownload_viewer">;
  } | null;
};
export type ProjectPortfolioMonthByMonthClientDownload_Query = {
  variables: ProjectPortfolioMonthByMonthClientDownload_Query$variables;
  response: ProjectPortfolioMonthByMonthClientDownload_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeOpportunityActuals"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expenseSearchQuery"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ignoreBaselineWinChance"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedSingleValue"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeSearchQuery"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_portfolio_month_by_month_client_csv_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_portfolio_month_by_month_client_csv_loader\")"
},
v14 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v15 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v16 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v17 = {
  "kind": "Variable",
  "name": "excludeOpportunityActuals",
  "variableName": "excludeOpportunityActuals"
},
v18 = {
  "kind": "Variable",
  "name": "ignoreBaselineWinChance",
  "variableName": "ignoreBaselineWinChance"
},
v19 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v20 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v21 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v22 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v24 = {
  "kind": "Literal",
  "name": "aggregateLevel",
  "value": "MONTH"
},
v25 = {
  "items": [
    {
      "kind": "Variable",
      "name": "aggregates.0",
      "variableName": "selectedSingleValue"
    }
  ],
  "kind": "ListValue",
  "name": "aggregates"
},
v26 = {
  "kind": "Literal",
  "name": "fetchOwnData",
  "value": true
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectPortfolioMonthByMonthClientDownload_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "args": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "kind": "Variable",
                "name": "expenseSearchQuery",
                "variableName": "expenseSearchQuery"
              },
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "kind": "Variable",
                "name": "selectedSingleValue",
                "variableName": "selectedSingleValue"
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "kind": "Variable",
                "name": "timeSearchQuery",
                "variableName": "timeSearchQuery"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ProjectPortfolioMonthByMonthClientDownload_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v10/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectPortfolioMonthByMonthClientDownload_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/)
                ],
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "financialBasedClients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          },
                          {
                            "alias": "timeAggregatedFinancialNumbers",
                            "args": [
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v26/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "searchQuery",
                                "variableName": "timeSearchQuery"
                              },
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          },
                          {
                            "alias": "expenseAggregatedFinancialNumbers",
                            "args": [
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v26/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "searchQuery",
                                "variableName": "expenseSearchQuery"
                              },
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83d464dd535552b800fc39c6d8d36e70",
    "id": null,
    "metadata": {},
    "name": "ProjectPortfolioMonthByMonthClientDownload_Query",
    "operationKind": "query",
    "text": "query ProjectPortfolioMonthByMonthClientDownload_Query(\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $searchQuery: TaskSearchQueryType!\n  $timeSearchQuery: TaskSearchQueryType!\n  $expenseSearchQuery: TaskSearchQueryType!\n  $selectedSingleValue: FinancialAggregatedNumber!\n  $ignoreBaselineWinChance: Boolean\n  $excludeOpportunityActuals: Boolean\n) {\n  viewer {\n    actualPersonId\n    component(name: \"project_portfolio_month_by_month_client_csv_loader\")\n    ...ProjectPortfolioMonthByMonthClientDownload_viewer_3H0CLP\n    id\n  }\n}\n\nfragment ProjectPortfolioMonthByMonthClientDownload_viewer_3H0CLP on Viewer {\n  id\n  company {\n    currency\n    financialBasedClients(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals) {\n      edges {\n        node {\n          id\n          name\n          aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n          timeAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $timeSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n          expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $expenseSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a020875ccdb9aaac081fee3f8d87bdc9";

export default node;
